import { render, staticRenderFns } from "./WarehousesSelector.vue?vue&type=template&id=59cceaee"
import script from "./WarehousesSelector.vue?vue&type=script&lang=js"
export * from "./WarehousesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports